import React from "react";

import { Navigate, useSearchParams } from "react-router-dom";

import { getExperimentStepPath } from "../routes";

export const ExperimentSetupRedirectPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const experimentId = searchParams.get("id") ?? undefined;

  return (
    <Navigate
      replace
      to={getExperimentStepPath("context", experimentId)}
    />
  );
};

export default ExperimentSetupRedirectPage;
